import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

// Sabitler
const PAGE_SIZE = 40;
const MAX_PAGES = 5;
const MAX_RECORDS = 200;

// Tüm sayfaları getiren fonksiyon
const fetchAllPages = async (apiClient, currentPage = 0) => {
  let allData = [];
  let hasMore = true;
  let page = currentPage;

  while (hasMore && page < MAX_PAGES) {
    try {
      const response = await apiClient.get(`/api/v1/predictions/btc/results?size=${PAGE_SIZE}&page=${page}`);
      const data = response.data || [];
      
      if (!data || data.length < PAGE_SIZE) {
        hasMore = false;
      }

      allData = [...allData, ...data];
      page++;

      if (allData.length >= MAX_RECORDS) {
        break;
      }
    } catch (error) {
      console.error(`Error fetching page ${page}:`, error);
      hasMore = false;
    }
  }

  return allData.slice(0, MAX_RECORDS);
};

export const getBitcoinInitialValue = createAsyncThunk(
  "api/v1/bitcoin/getInitialValue",
  async (_, thunkAPI) => {
    try {
      const apiClient = new APIClient();
      const response = await apiClient.get("/api/v1/predictions/btc/initial-result");
      return {
        status: true,
        data: response.data,
        timestamp: Date.now()
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getBitcoinPredictions = createAsyncThunk(
  "api/v1/bitcoin/getBitcoinPredictions",
  async (_, thunkAPI) => {
    try {
      const apiClient = new APIClient();
      const allData = await fetchAllPages(apiClient);

      // Initial değeri kontrol et
      const currentState = thunkAPI.getState().bitcoinPrediction;
      const lastOrder = allData[0];
      
      if (lastOrder?.change_position === "Initial" || !currentState.initialValue) {
        thunkAPI.dispatch(getBitcoinInitialValue());
      }

      return {
        status: true,
        data: allData,
        timestamp: Date.now(),
        totalRecords: allData.length
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const bitcoinPredictionSlice = createSlice({
  name: "bitcoinPrediction",
  initialState: {
    loading: false,
    payload: null,
    error: null,
    lastUpdated: null,
    totalRecords: 0,
    hasMoreData: true,
    initialValue: null,
    initialValueLoading: false,
    initialValueError: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBitcoinPredictions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBitcoinPredictions.fulfilled, (state, action) => {
        state.loading = false;
        state.payload = action.payload;
        state.lastUpdated = new Date().toISOString();
        state.totalRecords = action.payload.data.length;
        state.hasMoreData = action.payload.data.length >= PAGE_SIZE;
      })
      .addCase(getBitcoinPredictions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getBitcoinInitialValue.pending, (state) => {
        state.initialValueLoading = true;
        state.initialValueError = null;
      })
      .addCase(getBitcoinInitialValue.fulfilled, (state, action) => {
        state.initialValueLoading = false;
        state.initialValue = action.payload.data;
      })
      .addCase(getBitcoinInitialValue.rejected, (state, action) => {
        state.initialValueLoading = false;
        state.initialValueError = action.payload;
      });
  },
});

export default bitcoinPredictionSlice.reducer; 